import { createAction } from 'redux-starter-kit';

export const SET_TOGGLE_MENU = 'ui/SET_TOGGLE_MENU';

export default {
  setToggleMenu: createAction(SET_TOGGLE_MENU),
};
